import React from "react";
import "./LocationPicker.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const LocationPicker = ({label, value, options, onChange}) => {

  return (
    <div className="location__wrapper">
      <Autocomplete
        id="location-select"
        sx={{ width: 300 }}
        options={options}
        autoHighlight
        getOptionLabel={(option) => option.label}
        renderInput={(params) => <TextField {...params} label={label} />}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default LocationPicker;
